import { Helmet } from 'react-helmet-async';
import { SITE_URL, SITE_NAME } from '@/lib/newsHelpers';

interface Props {
  title: string;
  description: string;
  path: string;
  jsonLd?: object | object[];
}

/**
 * Per-route head: unique title, description, canonical, og:* and twitter:*.
 * Overrides the sitewide defaults in index.html for JS-executing crawlers.
 */
const PageSeo = ({ title, description, path, jsonLd }: Props) => {
  const url = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};

export default PageSeo;
